import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DeferRenderingModule } from '../../directives/defer-rendering/defer-rendering.module';
import { OverlayMaskModule } from '../overlay-mask/overlay-mask.module';
import { ContentTemplate, OverlayComponent } from './overlay.component';

@NgModule({
  imports: [CommonModule, OverlayMaskModule, DeferRenderingModule],
  declarations: [OverlayComponent, ContentTemplate],
  exports: [OverlayComponent, ContentTemplate],
})
export class OverlayModule {}
